import { render, staticRenderFns } from "./user-dropdown.vue?vue&type=template&id=d1ca81e2&scoped=true"
import script from "./user-dropdown.vue?vue&type=script&lang=js"
export * from "./user-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ca81e2",
  null
  
)

export default component.exports